export const allStaffManagementRoute: string = "all-staff-management";
export const staffManagementRoute: string = "staff-management";
export const roleDescriptionRoute: string = "role-description";